import axiosClient from "../axiosClient";

const getToken = () => {
  return (
    (localStorage?.auth && JSON.parse(localStorage.auth)?.token) || undefined
  );
};

const getRequests = (params) => {
  return axiosClient.get("requests", {
    params,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};
const getRequestDetail = (id) => {
  return axiosClient.get("requests/" + id, {
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};

export { getRequests, getRequestDetail };
